import { getReviewId } from '../../../_hooks/getReviewId';
import { useConsolidateResolution886Report } from '@/hooks/v2/resolution-886/useConsolidateResolution886Report';
import { useGetResolution886Report } from '@/hooks/v2/resolution-886';
import type { Resolution886ReportResponse } from '@/context/Resolution886Report/types';

export const useConsolidate = (
	report: Resolution886ReportResponse,
	companyId: string,
	organizationId: string,
	selectedReviewId?: string
) => {
	const { isLoading: consolidateReportLoading, mutateAsync: consolidateReport } = useConsolidateResolution886Report();

	const { data: reportData } = useGetResolution886Report({
		organization_id: organizationId,
		company_id: companyId,
		id: report?.id
	});

	const currentReport = reportData || report;
	const actualReviewId = getReviewId(selectedReviewId, currentReport?.reviews || []);
	const selectedReview = (currentReport?.reviews as Array<{ id: string; consolidated?: boolean }>)?.find(
		(review) => review.id === actualReviewId
	);
	const isReportConsolidated = selectedReview?.consolidated;

	async function handleConsolidate(values: { status: boolean; include_fields?: string[] }): Promise<void> {
		if (!report?.id || !companyId || !organizationId || !actualReviewId) {
			return;
		}

		const parameters = {
			organization_id: organizationId,
			company_id: companyId,
			report_id: report.id,
			review_id: actualReviewId,
			consolidated: values.status,
			locale: window.navigator.language,
			include_fields: values.include_fields || []
		};

		await consolidateReport(parameters);
	}

	return {
		handleConsolidate,
		consolidateReportLoading,
		isReportConsolidated
	};
};
